export const BaseGlassMixin = {
  background:
    "linear-gradient(159deg, rgba(255, 255, 255, 0.7) 3.01%, rgba(255, 255, 255, 0.7) 103.3%)",
  backdropFilter: "blur(21px)",
  border: "none",
  boxShadow:
    "0 20px 25px -5px rgba(245, 218, 255, 0.10),0 8px 10px -6px rgba(52, 64, 84, 0.10)",
}

const GlassMixin = {
  ...BaseGlassMixin,
  "&:before": {
    content: '""',
    position: "absolute",
    inset: 0,
    padding: "2px",
    borderRadius: "16px",
    background:
      "linear-gradient(22deg, rgba(255,255,255,0.4) 0%, rgba(3,10,10,0) 49%, rgba(255,255,255,0.5) 100%)",
    WebkitMask:
      "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
    WebkitMaskComposite: "xor",
    maskComposite: "exclude",
    pointerEvents: "none",
    zIndex: 1,
  },
}

export const GlassMixinVariant1 = Object.assign({}, GlassMixin)
GlassMixinVariant1["&:before"].padding = 0

export const GlassMixinVariant2 = Object.assign({}, GlassMixin)
GlassMixinVariant2["boxShadow"] =
  "0 20px 25px -5px rgba(245, 218, 255, 0.10),0 8px 10px -6px rgba(52, 64, 84, 0.10)"

export default GlassMixin
